import { useState } from 'react';
import { SEOHead } from '../../../components/seo/SEOHead';
import { FAQEditor } from '../../../components/admin/FAQEditor';
import { SEOMetaEditor } from '../../../components/admin/SEOMetaEditor';

export default function ContentManagement() {
  const [tab, setTab] = useState<'faqs' | 'seo'>('faqs');

  return (
    <>
      <SEOHead title="Content — Admin" description="" canonicalPath="/admin/content" />

      <h1 className="font-display text-2xl font-bold text-ink">Content Management</h1>

      <div className="mt-4 flex gap-2 border-b border-line">
        {(['faqs', 'seo'] as const).map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
              tab === t ? 'border-seal-blue text-seal-blue' : 'border-transparent text-ink/60'
            }`}
          >
            {t === 'faqs' ? 'Global FAQs' : 'SEO Metadata'}
          </button>
        ))}
      </div>

      <div className="mt-6 max-w-2xl">
        {tab === 'faqs' ? <FAQEditor /> : <SEOMetaEditor />}
      </div>
    </>
  );
}
